<template>
  <popup
    :show.sync="is_popup_show"
    width="500px"
    @on-close="is_popup_show = false"
  >
    <div
      style="padding: 25px"
      class="flex flex-direction justify-center align-center"
    >
      <h1 class="text-left">拒绝接单</h1>
      <div
        class="text-666 margin-top-10 text-14 text-center"
        style="width: 335px; line-height: 22px"
      >
        请选择拒绝原因，协作平台优化您在平台的需求分配
      </div>
      <div class="margin-top-20 select">
        <Select
          class=""
          placeholder="请选择拒绝原因"
          v-model="reason"
        >
          <Option value="暂无空闲时间">暂无空闲时间</Option>
          <Option value="需求不符合能力范围">需求不符合能力范围</Option>
          <Option value="价格/费用不合理">价格/费用不合理</Option>
          <Option value="其他原因">其他原因</Option>
        </Select>
      </div>
      <textarea
        class="remark"
        v-model="remark"
        placeholder="补充说明（选填）"
      ></textarea>
      <div
        class="flex align-center justify-center w100"
        style="margin-top: 40px"
      >
        <button class="cancel-btn cu-btn" @click="is_popup_show = false">
          取消
        </button>
        <button class="confirm-btn cu-btn margin-left-10" @click="confirm()">
          确认拒绝
        </button>
      </div>
    </div>
  </popup>
</template>

<script>
import Popup from "@/components/Popup.vue";
import { OrderMakeReject } from "@/api/index.js";
export default {
  name: "Accept",
  data() {
    return {
      is_popup_show: false,
      order: {},
      isSuccess: true,
      reason: "",
      remark: "",
    };
  },
  components: {
    Popup,
  },
  props: {},
  mounted() {},
  methods: {
    showModal(order) {
      this.order = order;
      this.is_popup_show = true;
    },
    confirm() {
      if (!this.reason) {
        return this.$layer.msg("请选择拒绝原因");
      }
      OrderMakeReject({
        reject_reason: this.reason,
        reject_memo: this.remark,
        uuid: this.order.uuid,
      })
        .then(() => {
          this.is_popup_show = false;
          this.$emit("confirm");
        })
        .catch((e) => {
          this.$layer.msg(e.msg);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.cancel-btn {
  width: 130px;
  height: 44px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #e3e3e3;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
}
.confirm-btn {
  width: 130px;
  height: 44px;
  background: #ff5967;
  border-radius: 4px 4px 4px 4px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
}
.select {
  width: 100%;
  height: 48px;
  ::v-deep .ivu-select {
    height: 100% !important;
    div {
      span {
        height: 100%;
        line-height: 48px;
      }
    }
  }
  ::v-deep .ivu-select-single .ivu-select-selection {
    height: 100% !important;
  }
}
.remark {
  width: 100%;
  height: 100px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #e3e3e3;
  margin-top: 12px;
  padding: 12px 16px;
}
</style>
